import { useConversationsContext } from '~/contexts/ConversationContext'
import { useConversationUuid } from '../conversation/useConversationUuid'
import { useTask } from '~/contexts/TaskContext'

export function useTaskLastUpdated(): number | null {
  const { task: taskObj } = useTask()
  const uuid = useConversationUuid()
  const { conversations } = useConversationsContext()

  if (taskObj == null) {
    const conversation = conversations.find((c: any) => c.uuid === uuid)
    // This is task_udpated_at is not the one we want to use
    // Fix it later. Another way to do this is to join the taskObj to
    // conversation object. So when toggling between tasks, we can get the
    // last updated time from the task object.
    return conversation?.task_updated_at || null
  }

  const items = taskObj.details.orderedStateResponses
  const resopnse = items[items.length - 1]
  return Number(resopnse!.createdTsSec) * 1000
}
